<template>
    <el-row :gutter="15">
        <el-col :span="10">

            <kl-label :title="$t('龙翼简报.车辆信息')" icon="icon-icon_top_aqjk" bold :fontSize="14"
                style="margin-bottom: 12px;" />
            <item :title="$t('龙翼简报.运营车辆数')+' / '+$t('龙翼简报.总车辆数')" :value="info.TotalVehicleCount+' / '+info.VehicleCount" :unit="$t('public.cars')" />
            <kl-label :title="$t('龙翼简报.能耗曲线')" icon="icon-icon_top_aqjk" bold :fontSize="14"
                style="margin-bottom: 12px;margin-top: 12px;" />
            <div style="width: 100%;height: 280px;border: 1px solid #C5D0E2;
border-radius: 2px;" :id="chartId" v-loading="loading"></div>
        </el-col>
        <el-col :span="14">

            <kl-label :title="$t('龙翼简报.里程统计')" icon="icon-icon_top_aqjk" bold :fontSize="14"
                style="margin-bottom: 12px;" />
            <el-row :gutter="20">
                <el-col :span="8">
                    <item :title="$t('龙翼简报.总里程')" unit="km" :value="info.RunMileage" />
                </el-col>
                <el-col :span="8">
                    <item :title="$t('龙翼简报.单车平均总里程')" unit="km" :value="info.VRunMileage" />
                </el-col>
                <el-col :span="8">
                    <item :title="$t('龙翼简报.单车每日平均里程')" unit="km" :value="info.DRunMileage" />
                </el-col>
            </el-row>
            <div style="margin-top: 12px;">

                <kl-label :title="$t('龙翼简报.能耗统计')" icon="icon-icon_top_aqjk" bold :fontSize="14"
                    style="margin-bottom: 12px;" />
                <el-row :gutter="20">
                    <el-col :span="8">
                        <item :title="$t('龙翼简报.总能耗')" unit="kW·h" :value="info.ElecConsume" />
                    </el-col>
                    <el-col :span="8">
                        <item :title="$t('龙翼简报.单车平均总能耗')" unit="kW·h" :value="info.VElecConsume" />
                    </el-col>
                    <el-col :span="8">
                        <item :title="$t('龙翼简报.平均百公里能耗')" unit="kW·h/100km" :value="info.DElecConsume" />
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 12px;">

                <kl-label :title="$t('龙翼简报.时间统计')" icon="icon-icon_top_aqjk" bold :fontSize="14"
                    style="margin-bottom: 12px;" />
                <el-row :gutter="20">
                    <el-col :span="8">
                        <item :title="$t('龙翼简报.运营总时长')" unit="Hour" :value="info.RunDuration" />
                    </el-col>
                    <el-col :span="8">
                        <item :title="$t('龙翼简报.单车平均运营总时长')" unit="Hour" :value="info.VRunDuration" />
                    </el-col>
                    <el-col :span="8">
                        <item :title="$t('龙翼简报.每日平均运营时长')" unit="Hour" :value="info.DRunDuration" />
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 16px;" v-if="false">

                <kl-label title="安全驾驶" icon="icon-icon_top_aqjk" bold :fontSize="14" style="margin-bottom: 12px;" />
                <el-row :gutter="20">
                    <el-col :span="8">
                        <item title="超速" unit="次" :value="info.OverSpeed" />
                    </el-col>
                    <el-col :span="8">
                        <item title="急减速" unit="次" :value="info.SlowDown" />
                    </el-col>
                    <el-col :span="8">
                        <item title="空档滑行" unit="次" :value="info.SlideRec" />
                    </el-col>
                </el-row>
            </div>
        </el-col>
    </el-row>
</template>
<script>
import item from "./item"
// import * as echarts from "echarts"
import { mapState } from 'vuex'
import ElementResizeDetectorMaker from "element-resize-detector";
export default {
    props: {
        chartId: {
            type: String,
            default: "div_chart"
        },
        beginDate: {
            type: String,
            default: ""
        },
        endDate: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: "day"
        } //类型，按天还是按月

    },
    components: {
        item
    },
    computed: {
        ...mapState({
            size: state => state.app.size,
            operator: state => state.user.operator,
            vehiclesData: state => state.app.vehicles.data,
        })
    },
    watch: {
        beginDate() {
            //查询数据
            // console.log("2222")
            // console.log(this.beginDate)
            this.queryData();
            this.queryChartData();
        }
    },
    data() {
        return {
            chart: undefined,
            xData: [],
            loading: false,
            data: [],
            info: {

            },
        }
    },
    methods: {
        queryChartData() {
            //  console.log("ss")
            this.loading = true;
            this.$api.queryDashBoardChartData({
                CompanyID: this.operator.CompanyId,
                BeginTime: this.beginDate,
                EndTime: this.endDate,
                QueryType: this.type,
                QueryCount: 7,
                OperatorID: this.$store.getters.operator.OperatorId
            }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    let today = new Date().toISOString().split('T')[0];
                    if(this.beginDate === today){
                        res.data[0].value = this.info.ElecConsume;
                    }
                    var xData = [];
                    var data = [];
                    res.data.reverse().forEach(element => {
                        xData.push(element.name)
                        data.push(element.value)

                    });


                    this.xData = xData;
                    this.data = data
                    this.loading = false;
                    if (this.chart)
                        this.chart.setOption({
                            xAxis: [
                                {
                                    data: this.xData,
                                }
                            ],
                            series: [
                                {
                                    data: this.data,
                                },
                                {
                                    data: this.data,
                                }
                            ]

                        })
                }
            });
        },
        queryData() {
            //车辆数
            //总里程 单车平均里程 单车每日平均里程
            //总能耗 单车平均总能耗 平均百公里能耗
            //运营总时长 单车平均运营总时长 每日平均运营时长
            //超速 急减速 急加速 空档滑行
            //[7天|7月]能耗曲线 (时间，值) 急减速 急加速 空档滑行

            let today = new Date().toISOString().split('T')[0];

            if(this.beginDate === today){
                this.$api.VelCalcData({
                optID: this.$store.getters.operator.OperatorId,
                vehicles:"",
                })
                .then((res)=>{
                    console.log(res);
                    if(res.code == 200){
                        let mileage = 0;
                        let avgspeed = 0;
                        let elecconsume = 0;
                        let oilconsume = 0;
                        let runtime = 0;
                        res.data.forEach((element)=>{
                            mileage += element.mileage;
                            elecconsume += element.elecconsume;
                            oilconsume += element.oilconsume;
                            runtime += element.runtime;
                            avgspeed += element.avgspeed;
                        })
                        this.info.TotalVehicleCount = res.recordsTotal;
                        this.info.VehicleCount = this.vehiclesData[0].totalCount;
                        this.info.ElecConsume = parseFloat(elecconsume.toFixed(2));
                        this.info.VElecConsume = parseFloat((elecconsume/res.recordsTotal).toFixed(2));
                        this.info.DElecConsume = parseFloat((this.info.ElecConsume / mileage * 100).toFixed(2));
                        this.info.RunDuration = parseFloat((runtime / 3600).toFixed(2));
                        this.info.DRunDuration = this.info.VRunDuration = parseFloat((this.info.RunDuration/res.recordsTotal).toFixed(2));
                        this.info.RunMileage = parseFloat(mileage.toFixed(2));
                        this.info.DRunMileage = this.info.VRunMileage = parseFloat((mileage/res.recordsTotal).toFixed(2));
                    }
                })
                return;
            }

                this.$api.queryDashBoardData({
                    CompanyID: this.operator.CompanyId,
                    BeginTime: this.beginDate,
                    EndTime: this.endDate,
                    type: this.type,
                    OperatorID: this.$store.getters.operator.OperatorId,
                }).then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.info = res.data;
                    }
                });

        },
        initChart() {
            if (!this.chart)
                this.chart = echarts.init(document.getElementById(this.chartId));

            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: '{b0} ' + this.$t("龙翼简报.总能耗") + ' {c0} kW·h'
                },
                grid: {
                    top: 30,
                    bottom: 0,
                    left: 20,
                    right: 20,
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.xData,
                        axisTick: {
                            alignWithLabel: true
                        }, axisLabel: {
                            color: "rgba(15,26,58,0.5)",
                            fontSize: 12
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value', axisLabel: {
                            color: "rgba(15,26,58,0.5)",
                            fontSize: 12
                        },
                        max: function (value) {
                            return value.max + 50;
                        }
                    }
                ],
                series: [
                    {
                        data: this.data,
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            color: "#2A7AFF"
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 1, color: 'rgba(42,122,255,0.00)' // 0% 处的颜色
                                }, {
                                    offset: 0, color: 'rgba(42,122,255,0.30)' // 100% 处的颜色
                                }],
                                globalCoord: false // 缺省为 false
                            }
                        }
                    },
                    {

                        type: 'bar',
                        barWidth: '15px',
                        data: this.data,
                        color: "#2A7AFF"
                    }
                ]
            };

            this.chart.setOption(option)

        }
    },

    mounted() {

        this.$nextTick(() => {
            this.initChart();
        })


        var ue = ElementResizeDetectorMaker();
        ue.listenTo(document.getElementById(this.chartId), () => {
            //页面大小变化
            this.$nextTick(() => {
                if (this.chart) {
                    this.chart.resize();
                }
            })
        })

    }
}
</script>